import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICarrier, ICarrierState } from "./carrierModel";
import {
  carrierActiveInactive,
  createCarrier,
  deleteCarrier,
  getAllActiveCarrier,
  getAllCarrier,
  getCarrierByID,
  updateCarrier,
} from "./services/carrier.services";

const initialState: ICarrierState = {
  loading: false,
  error: "",
  formLoading: false,
  CarrierID: null,
  CarrierList: [],
  CarrierDetail: {
    carrier_guid: "",
    carrier_name: "",
    city_id: null,
    state_id: null,
    country_id: null,
    contact_person: "",
    mobile_number: "",
    carrier_type: "",
    address: "",
    isactive: 1,
  },
};

const carrierSlice = createSlice({
  name: "carrier",
  initialState,
  reducers: {
    clearCarrierDetails: (state) => {
      state.CarrierDetail = initialState.CarrierDetail;
    },
    setCarrierID: (state, action) => {
      state.CarrierID = action.payload;
    },
    clearCarrierID: (state) => {
      state.CarrierID = initialState.CarrierID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllCarrier.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllCarrier.fulfilled,
      (state, action: PayloadAction<ICarrier[]>) => {
        state.loading = false;
        state.CarrierList = action.payload || [];
      }
    );
    builder.addCase(getAllCarrier.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.CarrierList = [];
    });
    builder.addCase(createCarrier.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createCarrier.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createCarrier.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateCarrier.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateCarrier.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateCarrier.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteCarrier.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteCarrier.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteCarrier.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getCarrierByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getCarrierByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.CarrierDetail = action.payload;
    });
    builder.addCase(getCarrierByID.rejected, (state, action) => {
      state.loading = false;
      state.CarrierDetail = initialState.CarrierDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveCarrier.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveCarrier.fulfilled,
      (state, action: PayloadAction<ICarrier[]>) => {
        state.loading = false;
        state.CarrierList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveCarrier.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.CarrierList = [];
    });
    builder.addCase(carrierActiveInactive.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(carrierActiveInactive.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(carrierActiveInactive.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearCarrierDetails, clearCarrierID, setCarrierID } =
  carrierSlice.actions;
export default carrierSlice.reducer;
